import { type ReactNode } from 'react';
import { RouterLink } from '../RouterLink';
import { useNavigationSectionContext, type NavigationSectionContextValue } from './NavigationSectionContext';
import { ButtonLink } from './ButtonLink';
import { cn } from '~/shared/components/utils';

function getPath(path: string, section: NavigationSectionContextValue | null) {
	if (path.startsWith('/')) {
		return path;
	}
	if (!section || section.includeSectionInPath === false) {
		return path;
	}
	return `${section.sectionName}/${path}`;
}

export function NavigationSectionLink({
	label,
	path,
	end = false,
	className,
	children
}: {
	label: string;
	path?: string;
	end?: boolean;
	className?: string;
	children?: (selected: boolean) => ReactNode;
}) {
	const section = useNavigationSectionContext();
	const itemClassName = cn(section && 'border-b-0 pl-8', className);
	if (path === null || path === undefined) {
		return (
			<ButtonLink label={label} className={itemClassName}>
				{children}
			</ButtonLink>
		);
	}

	const fullPath = getPath(path, section);
	return (
		<RouterLink path={fullPath} replaceLastPathOnly={end}>
			{(selected, navigateTo) => (
				<ButtonLink label={label} selected={selected} onClick={navigateTo} className={itemClassName}>
					{children}
				</ButtonLink>
			)}
		</RouterLink>
	);
}
